module.exports = __webpack_public_path__ + "static/img/image009.312befb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image009.png
// module id = WUCU
// module chunks = 1